import { render, staticRenderFns } from "./CustomersNav.vue?vue&type=template&id=4e721238&"
import script from "./CustomersNav.vue?vue&type=script&lang=js&"
export * from "./CustomersNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports